import Vue from 'vue';
import {
  GET_MARKETS_REQUEST,
  GET_MARKETS_SUCCESS,
  GET_MARKETS_ERROR,
  GET_CLIENT_MARKETS_REQUEST,
  GET_CLIENT_MARKETS_SUCCESS,
  GET_CLIENT_MARKETS_ERROR,
  UPDATE_MARKET_ERROR,
  UPDATE_MARKET_SUCCESS,
  UPDATE_MARKET_REQUEST
} from './actionTypes';
import marketApi from '../../_api/market';

const state = {
  markets: [],
  cmarkets: [],
  umarkets: [],
  status: '',
  errors: [],
  hasLoadedOnce: false
};

const getters = {
  markets: (state) => state.markets
};

const actions = {
  [GET_MARKETS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_MARKETS_REQUEST);
      marketApi
        .getMarkets()
        .then((response) => {
          commit(GET_MARKETS_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_MARKETS_ERROR, error);
          reject(error);
        });
    });
  },
  [GET_CLIENT_MARKETS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_CLIENT_MARKETS_REQUEST);
      marketApi
        .getClientMarkets(payload)
        .then((response) => {
          commit(GET_CLIENT_MARKETS_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_CLIENT_MARKETS_ERROR, error);
          reject(error);
        });
    });
  },

  [UPDATE_MARKET_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(UPDATE_MARKET_REQUEST);
      marketApi
        .updateMarket(payload)
        .then((response) => {
          commit(UPDATE_MARKET_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(UPDATE_MARKET_ERROR, error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [GET_MARKETS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_MARKETS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'markets', response.data);
  },
  [GET_MARKETS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_CLIENT_MARKETS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_CLIENT_MARKETS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'cmarkets', response.data.results);
  },
  [GET_CLIENT_MARKETS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [UPDATE_MARKET_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [UPDATE_MARKET_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [UPDATE_MARKET_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
